import { DataTable } from '../DataTable/DataTable'
import { buildConfigsTableColumns } from './helpers/buildConfigsTableColumns'
import type { ConfigsTableProps } from './ConfigsTable.types'
import './ConfigsTable.css'

export function ConfigsTable({
  configs,
  venues,
  onRowClick,
}: ConfigsTableProps) {
  return (
    <DataTable
      columns={buildConfigsTableColumns(venues)}
      data={configs}
      rowKey={(c) => c.id}
      emptyMessage="No configs found."
      onRowClick={onRowClick}
    />
  )
}
